import { HTTP } from '@/utils/http';
import * as actions from '../types/actions';

export default {
  actions: {
    async [actions.DO_CREATE_FORM_BLOCK]({ commit }, payload) {
      const { id } = payload;
      const params = Object.assign({}, payload);
      delete params.id;
      const { data } = await HTTP.post(`/forms/${id}/form_blocks`, params);
      return data;
    },
    async [actions.DO_OVERRIDE_FORM_BLOCK]({ commit }, payload) {
      const { id } = payload;
      const params = Object.assign({}, payload);
      delete params.id;
      const { data } = await HTTP.put(`/form_blocks/${id}`, params);
      return data;
    },
    async [actions.DO_UPDATE_FORM_BLOCK]({ commit }, payload) {
      const { id } = payload;
      const params = Object.assign({}, payload);
      delete params.id;
      const { data } = await HTTP.patch(`/form_blocks/${id}`, params);
      return data;
    },
    async [actions.DO_DELETE_FORM_BLOCK]({ commit }, payload) {
      const { id } = payload;
      const params = Object.assign({}, payload);
      delete params.id;
      const { data } = await HTTP.delete(`/form_blocks/${id}`, params);
      return data;
    },
    async [actions.DO_DELETE_FORM_BLOCKS]({ commit }, payload) {
      const { id } = payload;
      const params = Object.assign({}, payload);
      delete params.id;
      const { data } = await HTTP.delete(`/forms/${id}/form_blocks`, params);
      return data;
    },
  },
  getters: {},
  mutations: {},
  state: {},
};



// WEBPACK FOOTER //
// ./src/store/modules/form_block.js